export const FormLabel = {
  baseStyle: {
    fontSize: 'md',
    fontWeight: 'semibold',
    lineHeight: 'base',
    mb: 1
  }
}
